import { useEffect, useReducer } from "react";
import { fetchToggles } from "./togglesGateway";

export interface TogglesHookResponse {
    loading: boolean;
    error: boolean;
    toggles: {
        [toggleName: string]: boolean;
    };
    togglesRetrieved: boolean;
}

export interface Action {
    type: string;
    toggles?: {
        [toggleName: string]: boolean;
    };
}

const SET_LOADING = "SET_LOADING";
const SET_TOGGLES = "SET_TOGGLES";
const SET_ERROR = "SET_ERROR";

export function useToggles(togglesEndpoint: string): TogglesHookResponse {

    const toggleReducer = (state: TogglesHookResponse, action: Action) => {
        switch (action.type) {
            case SET_LOADING: return {...state, loading: true, error: false}
            case SET_ERROR: return {...state, error: true, loading: false, togglesRetrieved: true}
            case SET_TOGGLES: return {...state, toggles: {...action.toggles}, loading: false, togglesRetrieved: true}
            default: return state
        }
    }

    const initialToggleState = {
        loading: true,
        error: false,
        toggles: {},
        togglesRetrieved: false
    }

    const [{ loading, error, toggles, togglesRetrieved }, dispatch] = useReducer(toggleReducer, initialToggleState)

    useEffect(() => {
        const fetch = async (): Promise<void> => {
            try {
                dispatch({type: SET_LOADING})
                const togglesResponse = await fetchToggles(togglesEndpoint);
                dispatch({type: SET_TOGGLES, toggles: togglesResponse})
            } catch (e) {
                dispatch({type: SET_ERROR})
            }
        };
        void fetch();
    }, []);

    return { loading, error, toggles, togglesRetrieved };
}
